import { PRESET_ACCOUNT_GROUPS } from "@/lib/accountGroups";

/** Recompute open orders / lots by client group using live WS metrics. */
export function computeLiveClientStats(fleet = [], liveMetrics = {}) {
  const bucketMap = {};
  for (const g of PRESET_ACCOUNT_GROUPS) {
    bucketMap[g.name] = {
      group: g.name,
      color: g.color,
      orders: 0,
      lots: 0,
      accounts: 0,
      active_accounts: 0,
    };
  }
  bucketMap.__unassigned__ = {
    group: null,
    label: "Unassigned",
    color: "#94A3B8",
    orders: 0,
    lots: 0,
    accounts: 0,
    active_accounts: 0,
  };

  let totalOrders = 0;
  let totalLots = 0;
  let accountsWithOrders = 0;

  for (const row of fleet) {
    const live = liveMetrics[row.id];
    const isConnected = live?.ea_connected !== undefined ? Boolean(live.ea_connected) : Boolean(row.ea_connected);
    const orders = isConnected ? Number(live?.open_positions ?? live?.positions_count ?? row.open_positions ?? 0) : 0;
    const lots = isConnected ? Number(live?.total_lots ?? row.total_lots ?? 0) : 0;
    totalOrders += orders;
    totalLots += lots;
    if (orders > 0) accountsWithOrders += 1;

    let key = "__unassigned__";
    if (row.group) {
      if (!bucketMap[row.group]) {
        bucketMap[row.group] = {
          group: row.group,
          color: row.group_color || "#94A3B8",
          orders: 0,
          lots: 0,
          accounts: 0,
          active_accounts: 0,
        };
      }
      key = row.group;
    }

    const bucket = bucketMap[key];
    bucket.orders += orders;
    bucket.lots += lots;
    bucket.accounts += 1;
    if (orders > 0) bucket.active_accounts += 1;
    if (row.group_color && row.group) bucket.color = row.group_color;
  }

  const ordered = [];
  const presetNames = new Set(PRESET_ACCOUNT_GROUPS.map((g) => g.name));

  for (const g of PRESET_ACCOUNT_GROUPS) {
    ordered.push({
      ...bucketMap[g.name],
      lots: Math.round(bucketMap[g.name].lots * 100) / 100,
    });
  }

  for (const name of Object.keys(bucketMap)) {
    if (name !== "__unassigned__" && !presetNames.has(name)) {
      ordered.push({
        ...bucketMap[name],
        lots: Math.round(bucketMap[name].lots * 100) / 100,
      });
    }
  }

  const unassigned = bucketMap.__unassigned__;
  if (unassigned.accounts > 0) {
    ordered.push({
      ...unassigned,
      lots: Math.round(unassigned.lots * 100) / 100,
    });
  }

  return {
    total_orders: totalOrders,
    total_lots: Math.round(totalLots * 100) / 100,
    accounts_with_orders: accountsWithOrders,
    by_client: ordered,
  };
}
